module.exports = __webpack_public_path__ + "img/layout_fish_right.f42c74cc.svg";